import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');

  if (!token) {
    // Redirect to login if no token is found
    return <Navigate to="/login" replace />;
  }

  // If children are provided, render them; otherwise render the Outlet (for nested routes)
  return children ? children : <Outlet />;
};

export default ProtectedRoute;
